export const ACCOUNT_PROFILE = 'account.profile';

export const lblProfileEmailUsedLogin = 'lbl_profile_email_used_login';
export const lblProfilePersonalInfoPhoneNumber = 'lbl_profile_personal_info_phoneNumber';
export const lblProfilePersonalInfoBirthday = 'lbl_profile_personal_info_birthday';
export const lblProfilePersonalInfoMonth = 'lbl_profile_personal_info_month';
export const lblProfilePersonalInfoYear = 'lbl_profile_personal_info_year';
export const lblProfileCelebrationBirthday = 'lbl_profile_celebration_birthday';
export const lblProfilePersonalInfoTcpEmployee = 'lbl_profile_personal_info_tcp_employee';
export const lblProfilePersonalInfoAssociateId = 'lbl_profile_personal_info_associate_id';
export const lblProfilePersonalInfoUpdateCta = 'lbl_profile_personal_info_updateCta';
export const lblProfilePersonalInformation = 'lbl_profile_personal_information';

const AddEditPersonalInformationLabels = {
  account: {
    profile: {
      [lblProfileEmailUsedLogin]: 'Your email will be used to login to your account',
      [lblProfilePersonalInfoPhoneNumber]: 'Phone Number ',
      [lblProfilePersonalInfoBirthday]: 'Birthday',
      [lblProfilePersonalInfoMonth]: 'Month',
      [lblProfilePersonalInfoYear]: 'Year',
      [lblProfileCelebrationBirthday]: '',
      [lblProfilePersonalInfoTcpEmployee]: "I'm an employee of The Children's Place",
      [lblProfilePersonalInfoAssociateId]: 'Associate ID',
      [lblProfilePersonalInfoUpdateCta]: 'UPDATE INFO',
      [lblProfilePersonalInformation]: 'Personal Information',
      lbl_profile_ASSOCIATE_ID_DOES_NOT_EXIST:
        'The Associate ID you entered does not exist. Please try again.',
      lbl_profile_ASSOCIATE_ID_NOT_VALID:
        "The Associate ID you entered doesn't match the name in our records. Please try again.",
      lbl_profile_DEFAULT_ERROR:
        "We're sorry that we 're unable to complete your birthday savings request at this time.Please try again later.",
      lbl_profile__ERR_INVALID_COOKIE:
        'Your log in may have been used in another location. For your security, we have logged you out. Please click "Log Out"  at the top of the site and then log in again.',
      lbl_profile__TCP_EMAIL_ADDRESS_ALREADY_EXIST:
        'Error: An account with this email address already exists. Please try logging in with your account or using a different email address',
    },
  },
};
export default AddEditPersonalInformationLabels;
